import { useState } from "react";
import styled from "styled-components";

import { H5 } from "components/atoms/text";
import COLORS from "components/atoms/colors";
import InputText from "components/atoms/input/Text";
import Btn from "components/atoms/buttons";
import DropdownMenu from "components/organisms/DropdownMenu";
import FormImage from "components/templates/project/SideBar/Library/FormImage";

import Scene from "types/Scene";
import useInput from "hooks/useInput";
import useEditScene from "apis/mutations/scene/useEditScene";
import useDeleteScene from "apis/mutations/scene/useDeleteScene";
import useEditScenePosition from "apis/mutations/scene/useEditScenePosition";

interface Props {
  index: number;
  scene: Scene;
}

// 씬 목록 아이템
const ItemContent = ({ index, scene }: Props) => {
  const { title, image } = scene;

  const [showForm, setShowForm] = useState(false);
  const [sceneState, dispatch] = useInput({
    title,
    image,
  });

  // 씬 순서 업데이트 api
  const editScenePoisition = useEditScenePosition(scene.projectId);

  // 씬 수정 api
  const editScene = useEditScene({
    projectId: scene.projectId,
    sceneId: scene.id,
  });

  // 씬 삭제 api
  const deleteScene = useDeleteScene({
    sceneId: scene.id,
    projectId: scene.projectId,
    options: {
      onSuccess: (project) => {
        // 씬 순서 업데이트
        const data = [...project.scenes].map((item, index) => ({
          sceneId: item.id,
          position: index + 1,
        }));
        editScenePoisition({ data });
      },
    },
  });

  // 씬 수정하기 이벤트
  const handleEditScene = () => {
    if (!sceneState.title || !sceneState.image) return;
    editScene(sceneState);
    setShowForm(false);
  };

  return (
    <>
      <div className="absolute right-0 z-[2]">
        <DropdownMenu
          onOpenForm={() => setShowForm(true)}
          icon={{ size: 24, color: COLORS.black["20%"] }}
          onDelete={deleteScene}
        />
      </div>

      {showForm ? (
        <>
          <FormImage
            name={`scene${index}`}
            image={sceneState.image}
            onDispatch={(option) => dispatch({ option })}
          />
          <div className="flex flex-col justify-end pb-2">
            <H5>Scene {index + 1}</H5>
            <div className="flex gap-2">
              <InputText
                small
                placeholder="실명을 기입해주세요."
                name="title"
                value={sceneState.title}
                onChange={(event) => dispatch({ event })}
                shape="square"
                className={{
                  input: "placeholder:text-xxs",
                  container: "!px-2",
                }}
              />
              <Btn.Blue
                onClick={handleEditScene}
                size="xsSmall"
                inActive={!sceneState.title}
              >
                저장
              </Btn.Blue>
            </div>
          </div>
        </>
      ) : (
        <>
          <Box className="rounded-8 overflow-hidden">
            <img src={image} alt="" />
          </Box>
          <div className="flex flex-col justify-end pb-2">
            <H5>Scene {index + 1}</H5>
            <p className="text-black-60%">{title}</p>
          </div>
        </>
      )}
    </>
  );
};

const Box = styled.div`
  flex: none;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 148px;
  height: 100px;
  border-radius: 8px;
  background-color: ${COLORS.white["60%"]};
`;

export default ItemContent;
